module.exports = __webpack_public_path__ + "img/4f_r_jindaiji.b79a0343.jpg";